import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { http } from '@/lib/api/client'
import type { Briefing, Resource } from '@/lib/api/types'

export type BriefingRange = Briefing['range']

/** The Briefing's figures, refreshed every minute like the menu's counts. */
export function useBriefing(range: BriefingRange) {
  return useQuery({
    queryKey: ['briefing', range],
    queryFn: async () => (await http.get<Resource<Briefing>>('/briefing', { range })).data,
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  })
}
